import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { LabResult, logoString } from 'src/app/models';
import { LabRequisitionService, MessageService } from 'src/app/services';
import * as ZoneMoment from "moment-timezone";
import { CustomDatePipe } from 'src/app/pipes';
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.vfs;
var htmlToPdfmake = require("html-to-pdfmake");
@Component({
  selector: 'bart-print-lab-result',
  templateUrl: './print-lab-result.component.html',
  styleUrls: ['./print-lab-result.component.scss'],
  providers:[CustomDatePipe]
})
export class PrintLabResultComponent implements OnInit {
  @Output() pageLoadCompletedEvent = new EventEmitter();
  @Input() facilityMasterId:number;
  @Input() facilityDisplayName:string;
  @Input() labResults:LabResult[]=[];
  labResultsPrint :LabResult[]=[]
  facilityDetails: any;
  base64Url="";
  labResultColumn:any[];
  EquipmentDisplayName: string;
  
  constructor
  (  
    private _labRequisitionService: LabRequisitionService,
    private _messageService: MessageService,
    private customDatePipe :CustomDatePipe,
  ) 
  {
    this.toDataURL("assets/images/DaVita_OfficialLogoBlack.jpg",(dataUrl)=> 
    {
      this.base64Url=dataUrl
    });
  }

  ngOnInit() {
    this.labResultColumn =
      [
        { field: 'LabRequisitionNumber', header: 'REQUISITION ID', display: 'table-cell', width: "13%" },
        { field: 'TestDisplayName', header: 'TEST ID | NAME', display: 'table-cell', width: "15%" },
        { field: 'EquipmentDisplayName', header: 'MODEL # | SERIAL # | EQUIPMENT ID', display: 'table-cell', width: "22%" },
        { field: 'LabResult', header: 'RESULT | UNIT', display: 'table-cell', width: "10%" },
        { field: 'Status', header: 'STATUS', display: 'table-cell', width: "8%" },
        { field: 'DrawDate', header: 'DRAW DATE', display: 'table-cell', width: "15%" },
        { field: 'LabComments', header: 'LAB COMMENTS', display: 'table-cell', width: "17%" }
      ];
      this.labResults.forEach(item=>
        {
          if(item.IsProfile == true){
            let objTests=item.LabProfileTests;
            objTests.forEach(x=>
              { 
                let objLabResult : any  = {};
                objLabResult.LabRequisitionID  =item.LabRequisitionID       
                objLabResult.LabRequisitionNumber  =item.LabRequisitionNumber   
                objLabResult.TestDisplayName=x.TestDisplayName		  
                objLabResult.EquipmentDisplayName=item.EquipmentDisplayName     
                objLabResult.LabResult =x.TestResult           
                objLabResult.LabRange=x.LabRange
                objLabResult.LabComments=x.LabComments
                objLabResult.Status=x.LabResultStatus
                objLabResult.IsProfile=item.IsProfile
                objLabResult.DrawDate=item.DrawDate
                objLabResult.LabRequestID=item.LabRequestID
                objLabResult.IsRedraw=item.IsRedraw
                objLabResult.ReDrawStatus=item.ReDrawStatus
                objLabResult.ShippingDate=item.ShippingDate
                this.labResultsPrint.push(objLabResult)
              });
             
          }
          else{
              this.labResultsPrint.push(item)
           }
        });
    
      this.populatePDFDate();
  }

  populatePDFDate(){
    this.facilityDetails = [];
    let getFacilityParam = {
      "GETFACILITYINFO": {
        "facilityMasterId": this.facilityMasterId
      }
    }
    const FacilityDetailsUrl = this._labRequisitionService.getfacilityDetails(JSON.stringify(getFacilityParam));   
    const requestsArray = [];
    requestsArray.push(FacilityDetailsUrl);
    forkJoin(requestsArray).subscribe((response: any) => 
    {
      if(response!=null && response[0].length)
      {
        this.facilityDetails = response[0][0];
      }      
      this.createPDF();
    }, 
    (error) => 
    {
      this._messageService.setErrorPageMessage('Error Occurred while loading Master Data');
    });
  }
  createPDF(){ 
    let printDate=new Date();
    var timeZoneOffset =printDate.getTimezoneOffset();
    var timeZone = ZoneMoment.tz.guess();
    let currentTimezone =  ZoneMoment.tz.zone(timeZone).abbr(timeZoneOffset);
    let printFooterDate=this.customDatePipe.transform(printDate,"calender","MM/dd/yyyy H:mm:ss")+" "+currentTimezone 
    // let printFooterDate=this.customDatePipe.transform(this.printDate,"calender","MM/dd/yyyy H:mm:ss")
    let footerLine1=this.facilityDisplayName;
    let footerLine2=[this.facilityDetails.Address1, this.facilityDetails.City, this.facilityDetails.State, this.facilityDetails.Zip].filter(Boolean).join(", ");
   
     setTimeout(() => {
        try{
        var html = htmlToPdfmake(document.getElementById('printLabResult').innerHTML, {
          tableAutoSize: true
        }
        );
        var dd = {
          info :{
            title : "Lab Results"
          },
          pageMargins: [ 35, 50, 35, 80 ],
          content: html,
          pageSize:'LETTER',
          images:html.images,
          pageBreakBefore: function (currentNode:any) {
            return currentNode.style && currentNode.style.indexOf('pdf-pagebreak-before') > -1;
          },
          imagesByReference: true,
          header: function(currentPage, pageCount, pageSize) {
            // computations...
            return [
              {
               // margin:[20,0,0,0],
                columns: [
                  {
                    width: '92%',
                    text:[' ',' ',
                       'Lab Results '
                      ],
                    alignment:'left',
                    margin:[32,20,35,0],
                  },
                  {
                     image: logoString,
                     width: 50,
                     height : 20,
                     alignment:'right',
                     margin:[30,15,5,0]
                  },
                ],
                
              },
              {
                border: [true, true, false, false],
                table : {
                  headerRows : 1,
                  widths: [533],
                  body : [
                          [ {
                            text:"",
                            border: [ false, true, false, false ],
                           
                        }],
                        
                          ]
              },
              layout : {
               // "headerLineOnly": true,
                hLineWidth: function (i, node) {
                  return  1;
                },
                vLineWidth: function() {
                  return 0;
                }
              },
              margin:[35,10,0,0]
          }
            ]
          
          },
          footer: function(currentPage, pageCount) { 
            return  [
              {
                columns:[
                        { width:'100%',
                                      stack:[
                                        {
                                          canvas: [
                                            {
                                                type: 'line',
                                                x1: 30,
                                                y1: 30,
                                                x2: 575,
                                                y2: 30,
                                                lineWidth: 0.8
                                            }
                                        ]
                                        }
                                      ]
                                    }
                         ]
              },
              {
                columns: [  
                {
                  width: '20%',
                  stack:[' ',' ',
                     'Page ' +currentPage.toString() + ' of ' + pageCount,
                    ],
                  alignment:'left'
                },
                {
                  width: '60%',
                  stack:[ footerLine1,
                footerLine2,
                '© '+(new Date()).getFullYear()+' DaVita Inc.',
                ],
                  alignment:'center'
                },
                {
                  width: '20%',
                  stack:[ ' ',
                          'Printed',
                           printFooterDate
                ],
                  alignment:'right'
                }
              ],
              fontSize: 8,
              color:'gray',
              margin:[35,5,35,5]}
            ]
          },
        };
        pdfMake.createPdf(dd).open();
        this.pageLoadCompletedEvent.emit();
      }
      catch(ex){
        console.log('error in create pdf'+ex);
      } 
      }, 2000);  
    
  }
  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}
}
